export const slideData = [
  {
    id: 1,
    title: "Title",
    speakerNote:
      "AppellatePro.AI automates one of the most repetitive and expensive workflows in appellate litigation: preparing the Record on Appeal.",
  },
  {
    id: 2,
    title: "Problem",
    speakerNote:
      "This is not a strategy problem. It is a workflow problem. Lawyers are paying high prices for a process that should already be software.",
  },
  {
    id: 3,
    title: "Solution",
    speakerNote:
      "We are not helping lawyers do the same work slightly faster. We are replacing an entire manual service workflow with software.",
  },
  {
    id: 4,
    title: "Product",
    speakerNote:
      "The product handles the actual operational details that make this workflow painful: document gathering, ordering, formatting, pagination, and final assembly.",
  },
  {
    id: 5,
    title: "Why Now",
    speakerNote:
      "The underlying infrastructure now exists. The court systems are digitized enough, and law firms are far more open to adopting software that saves real money.",
  },
  {
    id: 6,
    title: "Market Opportunity",
    speakerNote:
      "We do not need to start with all of legal tech. We can start with one painful workflow, dominate it in New York, and then expand state by state.",
  },
  {
    id: 7,
    title: "Business Model",
    speakerNote:
      "This can start as transactional revenue and evolve into recurring SaaS revenue as firms integrate it into their standard appellate process.",
  },
  {
    id: 8,
    title: "Traction / Proof",
    speakerNote:
      "This is not a concept deck. The core software exists, the workflow is understood, and the value proposition is immediate.",
  },
  {
    id: 9,
    title: "Go-To-Market",
    speakerNote:
      "This is one of the strongest parts of the business. Demand becomes visible at the moment the legal need arises.",
  },
  {
    id: 10,
    title: "Competition",
    speakerNote:
      "The competition is not sophisticated legal software. It is a legacy service category with high margins and low technical leverage.",
  },
  {
    id: 11,
    title: "Team",
    speakerNote:
      "Our team combines decades of legal operations expertise, complex litigation experience, and proven technology leadership to build and scale this product.",
  },
  {
    id: 12,
    title: "Financial Projections",
    speakerNote:
      "The projections assume disciplined rollout: New York first, then broader geographic expansion as we adapt the workflow to additional court systems.",
  },
  {
    id: 12,
    title: "Fundraising",
    speakerNote:
      "The first tranche is designed to reward the earliest conviction and create momentum. Capital will be used to accelerate sales, product hardening, and state expansion.",
  },
  {
    id: 14,
    title: "Vision",
    speakerNote:
      "The wedge is narrow, but the platform opportunity is much larger. Once we own this workflow, we can expand into the broader appellate stack.",
  },
];
